import { useEffect, useState } from 'react';

import PaymentsOnHoldService from '../../../services/PaymentsOnHoldService';

interface PaymentsOnHoldFetchDocsOptions {
  disabled: boolean;
}

const usePaymentsOnHoldFetchDocs = (
  tradeId: number,
  documentType: number,
  options: PaymentsOnHoldFetchDocsOptions = { disabled: false }
) => {
  const [
    paymentsOnHoldUploadedDocs,
    setPaymentsOnHoldUploadedDocs
  ] = useState();

  // Make fetch uploaded seller funding docs API call
  useEffect(() => {
    if (paymentsOnHoldUploadedDocs === undefined && !options.disabled) {
      PaymentsOnHoldService.fetchUploadedSellerFundingDocs(
        tradeId,
        documentType
      )
        .then(response => {
          setPaymentsOnHoldUploadedDocs(response);
        })
        .catch(() => {});
    }
  }, [paymentsOnHoldUploadedDocs, tradeId, documentType, options.disabled]);

  return paymentsOnHoldUploadedDocs;
};

export default usePaymentsOnHoldFetchDocs;
